import React from 'react';

import { Box, Grid, Stack } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { useNavigate } from 'react-router-dom';

import analytics from '../firebase';
import { useFetchAllData } from '../hooks/useClientDataService';
import logo from '../images/logo.png';

import { StyledChip, useStyles } from './styled';

import { NavigationMenu, SearchBar } from '.';

import './styles.scss';

export const Header = () => {
  const navigate = useNavigate();

  const { data: allIdosList } = useFetchAllData();

  const styles = useStyles();

  const onClick = () => {
    navigate('/homeScreen');
  };
  const onSelect = (tokenID, tokenName, type) => {
    logEvent(analytics, 'USER_SEARCH', { tokenName: tokenName, tokenID: tokenID, type: type });

    if (type == 'IDO') {
      localStorage.setItem('tokenId', tokenID);
      navigate(`/tokenDetails/${tokenName}`);
    } else {
      localStorage.setItem('nftTokenId', tokenID);
      navigate(`/nftDetails/${tokenName}`);
    }
  };

  return (
    <Box className={styles.headerContainer}>
      <Grid container>
        <Grid item xs={12} md={3}>
          <Stack alignItems="center" direction="row" justifyContent="flex-start">
            <img src={logo} height="50px" className="logo" onClick={onClick} />
            <StyledChip
              label={'Beta'}
              fontColor={'#ffff'}
              variant="outlined"
              size="small"
              bgcolor={'#ff7101'}
              onClick={onClick}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <NavigationMenu />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <SearchBar options={allIdosList} onSelect={onSelect} />
        </Grid>
      </Grid>
    </Box>
  );
};
